import { atom } from 'recoil';

export const customerPagingAtom = atom<number>({
   key: 'customerPagingAtom',
   default: 0,
});
